import { unescape } from 'lodash';

import { Icon } from '@/components/icon';
import { ConfluenceIcon } from '@/components/icon/confluence';

import styles from './reference-block.module.scss';

export interface ConfluenceReferenceProps {
  url?: string;
  name?: string;
  type?: string;
  onOpen?: () => void;
}

export const ConfluenceReference = ({ url, name, type, onOpen }: ConfluenceReferenceProps) => (
  <div className={styles.confluenceBlock}>
    <div className={styles.icon}>
      <ConfluenceIcon size={32} />
    </div>
    <div className={styles.title}>
      {unescape(name)}
      <a
        href={url}
        rel="noopener noreferrer nofollow"
        target="_blank"
        className={styles.iconLink}
        draggable={false}
        onClick={onOpen}>
        <Icon name="ExternalLink" size={14} />
      </a>
    </div>
    <div className={styles.subtitle}>Confluence {type ?? 'page'}</div>
  </div>
);
